export const UPDATE_GEOLOCATION_PERMISSION_STATE =
  'UPDATE_GEOLOCATION_PERMISSION_STATE' as const

export const updateGeolocationPermissionStateAction = (
  permissionState: PermissionState | undefined
) => ({
  type: UPDATE_GEOLOCATION_PERMISSION_STATE,
  permissionState,
})
